import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "gif",
  "use": "gif-usage",
  "viewBox": "0 0 75.6 116.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 75.6 116.3\" id=\"gif\"><path fill=\"#e1b225\" d=\"M64 38H50.7V21.6H12v75.2h52\" /><path fill=\"#cc962b\" d=\"M64 38L50.7 21.6V38H64\" /><path fill=\"none\" d=\"M26.5 52.7h22.9v16.2H26.5z\" /><text transform=\"translate(26.517 63.985)\" font-size=\"15\" font-family=\"Roboto\" fill=\"#fff\">GIF</text></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/gif.svg
// module id = lClp
// module chunks = 1